const env = import.meta.env;

function readFirebaseEnv(name: string): string {
  const viteValue = env[`VITE_${name}`];
  const expoValue = env[`EXPO_PUBLIC_${name}`];
  const value = typeof viteValue === "string" && viteValue.length > 0 ? viteValue : expoValue;

  if (typeof value !== "string" || value.length === 0) {
    throw new Error(
      `Missing Firebase client config value. Set VITE_${name} or EXPO_PUBLIC_${name} in the root .env file.`
    );
  }

  return value;
}

export const firebaseConfig: Record<string, string> = {
  apiKey: readFirebaseEnv("FIREBASE_API_KEY"),
  authDomain: readFirebaseEnv("FIREBASE_AUTH_DOMAIN"),
  projectId: readFirebaseEnv("FIREBASE_PROJECT_ID"),
  storageBucket: readFirebaseEnv("FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: readFirebaseEnv("FIREBASE_MESSAGING_SENDER_ID"),
  appId: readFirebaseEnv("FIREBASE_APP_ID")
};
